import { TicketFile } from "@Pages/Tickets/SupportMachine/types";

import { Deal } from "./deal";
import { Lender } from "./lender";
import { LenderNote } from "./notes";
import { TitleIssue } from "./title_issues";
import { User } from "./users";

export enum Status {
  Open = "open",
  InProgress = "in progress",
  Sovled = "solved",
  Closed = "closed",
}

export interface FormState {
  info: Info;
  lenderNotes?: LenderNote[];
  dealId?: string;
  deal?: Deal;
  titleIssue?: TitleIssue;
  titleIssueId?: string;
  lenderId?: string;
  lender?: Lender;
  userId?: string;
  replyTo?: string[];
  assignees?: User[];
  assigneeIds?: string;
}

export interface Info {
  subject: string;
  status: Status;
  description: string;
  priority: Priority;
}

export enum Priority {
  Low = "low",
  Medium = "medium",
  High = "high",
}

export type LenderTicket = {
  createdAt: string;
  _id: string;
  data: FormState;
};
export type CreateTicketRequest = {
  files?: TicketFile[];
  data: FormState;
};

export const sortTickets = (tickets: LenderTicket[]) =>
  tickets.reduce(
    (acc, curr) => {
      return {
        ...acc,
        [curr.data.info.status]: acc[curr.data.info.status] + 1,
        all: acc.all + 1,
      };
    },
    {
      open: 0,
      "in progress": 0,
      solved: 0,
      closed: 0,
      all: 0,
    }
  );
